<!DOCTYPE html>
<meta name="viewport" content="width=device-width, initial-scale=1.0">


<div class="main-container">
  <div class="content">
    <!-- <img class="background-image" src="../../../assets/hero-rank/background.png" alt="backgroungImage" /> -->
    <img class="cloudImage1" src="../../../assets/hero-rank/Union_1.png" alt="cloud" />
    <img class="cloudImage4" src="../../../assets/hero-rank/Union_4.png" alt="cloud" />
    <img class="cloudImage3" src="../../../assets/hero-rank/Union_3.png" alt="cloud" />
    <img class="star1" src="../../../assets/hero-rank/Vector_1.png" alt="star" />
    <img class="star2" src="../../../assets/hero-rank/Vector_2.png" alt="star" />
    <img class="star3" src="../../../assets/hero-rank/Vector_3.png" alt="star" />
    <img class="star4" src="../../../assets/hero-rank/Vector_4.png" alt="star" />
    <img class="star5" src="../../../assets/hero-rank/Vector_4.png" alt="star" />
    @if (textDisable) {
      <div class="loading-content">{{"celebration.Levelling_up" | translate}}</div>
    }

    <!-- for community  -->
    @if (communityRocketVisible) {
      <div class="rocketAlignment">
        <ng-lottie [options]="community" loop="true" speed="0.1" class="rocket"></ng-lottie>
      </div>
    }
    <!-- for community -->

    <!-- for Fortune -->
    @if (fortuneRocketVisible) {
      <div class="rocketAlignment">
        <ng-lottie [options]="fortune" loop="true" speed="0.1" class="rocket"></ng-lottie>
      </div>
    }
    <!-- for Fortune  -->

    <!-- for Gaming -->
    @if (gamingRocketVisible) {
      <div class="rocketAlignment">
        <ng-lottie [options]="gaming" loop="true" speed="0.1" class="rocket"></ng-lottie>
      </div>
    }
    <!-- for Gaming  -->

    <!-- for VIP  -->
    <ng-container>
      <div class="rocketAlignment">
        @if (vipRocketVisible) {
          <ng-lottie [options]="vip" loop="true" speed="0.1" class="rocket"></ng-lottie>
        }
      </div>
    </ng-container>
    <!-- for VIP -->

    @if (levelUpContent && rankLevelData$ | async; as rankLevelData ) {
      <div>
        <div class="levelledUp">{{"celebration.You've" | translate}} <strong>{{"celebration.Levelled_up" |
        translate}}</strong>
      </div>
      <div class="animationContainer">
        <div class="pulsAnimation">
          <ng-lottie [options]="puls" loop="true" speed="0.1" class="Puls"></ng-lottie>
          <div class="batch">
            <img [ngClass]="celebrationTitle === 'VIP'?'vipIcon':'batchIcon'"
              [src]="celebrationTitle === 'VIP' ? '../../../../../assets/icon/VIP_Badge.svg' : rankLevelData?.badge"
              alt="batchImage" />
            </div>
          </div>
        </div>
        @if (greetingsContent) {
          <div class="fadeIn">
            <p class="greeting">{{"celebration.Congratulations" | translate}}</p>
            <strong class="level"> {{"celebration.You've_Level" | translate}} {{rankLevelData?.level}} </strong>
            <p class="heroName" [ngStyle]="{ 'color': textColors[celebrationTitle] } "> {{celebrationTitle}} </p>
            <div class="sentance">
              {{celebrationTitle === "VIP" ? ("celebration.Next_card" | translate): ("celebration.Your_gift" | translate)
              }}
              <br />
              {{celebrationTitle === "VIP" ? ("celebration.IN" | translate) + ' ' + rankLevelData?.remaining_level + ' ' +
              ("celebration.Levels" | translate): "celebration.Box_from" | translate}}
              <br>
                <br>
                </div>
                <!-- <button class="btn"
                (click)="celebrationTitle === 'VIP' ? closeDialog('OK') : closeDialog('Claim-gift') ">{{celebrationTitle ===
                "VIP" ? ("celebration.Ok" | translate) : ("celebration.Claim_gift" |
              translate) }}</button> -->
            </div>
          }
        </div>
      }
    </div>
    @if (levelUpContent && rankLevelData$ | async; as rankLevelData ) {
      <button class="btn"
        (click)="celebrationTitle === 'VIP' ? closeDialog('OK') : closeDialog('Claim-gift') ">{{celebrationTitle ===
        "VIP" ? ("celebration.Ok" | translate) : ("celebration.Claim_gift" |
      translate) }}</button>
    }
  </div>
